import * as types from '../constants/ActionTypes'

export default function practice_types(state = {}, action){
    switch(action.type){
        case types.SET_PRACTICE_TYPES:
            return action.payload

        case types.INSERT_PRACTICE_TYPE:
            return action.payload

        case types.DELETE_PRACTICE_TYPE:
            return action.payload

        case types.UPDATE_PRACTICE_TYPE:
            return action.payload

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/practice_type.js